module.exports = require("./../../_gen/starling/extensions/Particle");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/extensions/Particle.js
// module id = 191
// module chunks = 0